import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';
import * as adminTypes from '../../../../common/actionTypes/adminTypes';
import get from 'lodash/get';

const INITIAL_STATE = {
  isLoading: false,
  isMobileOtpLoading: false,
  isEmailOtpLoading: false,
  businessIds: [],
  isEmailVerified: false,
  isPhoneVerified: false,
  kycFormFields:{},
  userData: [],
  kycStaticData:{},
  kycDetails:{},
  isVerifyLoading: false,
  otp: ''
}

const reducer = {
  [adminTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => {
    return INITIAL_STATE;
  },
  [actionTypes.SET_LOADING_STATUS]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      isLoading: isLoading
    }
  },
  [actionTypes.SET_VERIFY_LOADING_STATUS]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      isVerifyLoading: isLoading
    }
  },
  [actionTypes.SET_MOBILE_OTP_LOADING_STATUS]: (state, action) => {
    const { isMobileOtpLoading, otpVerified } = action.payload;
    return {
      ...state,
      isMobileOtpLoading: isMobileOtpLoading,
      otpVerified: otpVerified

    }
  },
  [actionTypes.SET_EMAIL_OTP_LOADING_STATUS]: (state, action) => {
    const { isEmailOtpLoading, otpVerified } = action.payload;
    return {
      ...state,
      isEmailOtpLoading: isEmailOtpLoading,
      otpVerified: otpVerified

    }
  },
  [actionTypes.FETCH_KYC_FORM_FIELDS]: (state, action) => {
    const { kycFormFields } = action.payload;
    return {
      ...state,
      kycFormFields: kycFormFields
    };
  },
  [actionTypes.GET_KYC_STATIC_DATA]: (state, action) => {
    const { kycStaticData } = action.payload;
    return {
      ...state,
      kycStaticData: kycStaticData.data
    };
  },
  [actionTypes.FETCH_BUSINESS_IDS_SUCCESS]: (state, action) => {
    const { businessIds } = action.payload;
    return {
      ...state,
      isLoading: false,
      businessIds: businessIds
    }
  },
  [actionTypes.FETCH_BUSINESS_IDS_FAILED]: (state, action) => {
    return {
      ...state,
      isLoading: false
    }
  },
  [actionTypes.SEND_OTP_ON_EMAIL_SUCCESS]: (state, action) => {
    return {
      ...state,
      isEmailOtpLoading: false
    }
  },
  [actionTypes.SEND_OTP_ON_EMAIL_FAILED]: (state, action) => {
    return {
      ...state,
      isEmailOtpLoading: false
    }
  },
  [actionTypes.SEND_OTP_ON_MOBILE_SUCCESS]: (state, action) => {
    return {
      ...state,
      isMobileOtpLoading: false
    }
  },
  [actionTypes.SEND_OTP_ON_MOBILE_FAILED]: (state, action) => {
    return {
      ...state,
      isMobileOtpLoading: false
    }
  },
  [actionTypes.MOBILE_VERIFY_OTP_SUCCESS]: (state, action) => {
    const { userData, isConflictingUser, otp } = action.payload;
    return {
      ...state,
      isVerifyLoading: false,
      isPhoneVerified: !isConflictingUser,
      userData: userData,
      otp
    }
  },
  [actionTypes.MOBILE_VERIFY_OTP_FAILED]: (state, action) => {
    return {
      ...state,
      isVerifyLoading: false
    }
  },
  [actionTypes.EMAIL_VERIFY_OTP_SUCCESS]: (state, action) => {
    const { userData, isConflictingUser } = action.payload;
    return {
      ...state,
      isVerifyLoading: false,
      isEmailVerified: !isConflictingUser,
      userData: userData
    }
  },
  [actionTypes.GET_KYC_DETAILS]: (state, action) => {
    // User will have 1 email for all leads and once verified it will be verified for all
    const { kycDetails } = action.payload;
    const is_email_verified = get(kycDetails, 'personal_details.is_mail_verified', false);
    return {
      ...state,
      isEmailVerified: is_email_verified
    }
  },
  [actionTypes.EMAIL_VERIFY_OTP_FAILED]: (state, action) => {
    return {
      ...state,
      isVerifyLoading: false
    }
  }
}

export default createReducer(INITIAL_STATE, reducer);
